export default "packs/otp-background-image-9b72137aeda4d60ea0a86516e959fdbe.png";